module.exports = __webpack_public_path__ + "static/media/confetti.2c641526.gif";